<template>
  <div
    :class="{fixed: !closeFixed && isFixedFooter}"
    class="footer py-4"
  >
    <v-layout
      align-center
      class="mainPanel pt-2"
    >
      <v-flex class="pa-0 text-xs-center pt-2">
        <div class="about mb-2">
          <router-link :to="{name:'About'}">
            公司簡介
          </router-link>&nbsp;|&nbsp;
          <a @click="$store.dispatch('viewPost','security')">個人資料安全保障策略</a>&nbsp;|&nbsp;
          <a @click="$store.dispatch('viewPost','terms')">會員條款</a>&nbsp;|&nbsp;
          <a @click="$store.dispatch('viewPost','coop')">合作提案</a>&nbsp;|&nbsp;
          <a @click="$store.dispatch('viewPost','contact')">聯繫方式</a>
        </div>
        <div class="copyright">
          kkren.com.tw（巧巧郎）© 版權所有 {{ new Date().getFullYear() }}
        </div>
      </v-flex>
      <div class="caption">
        <div class="mb-1">
          掃碼下載APP
        </div>
        <v-layout>
          <div
            class="white black--text text-center mr-3"
            style="border-radius: 5px;"
          >
            <div>
              iOS
            </div>
            <v-divider />
            <img
              loading="lazy"
              decoding="async"
              src="../images/iosqr.png"
              width="70"
              height="70"
            >
          </div>
          <div
            class="white black--text text-center"
            style="border-radius: 5px;"
          >
            <div>
              Android
            </div>
            <v-divider />
            <img
              loading="lazy"
              decoding="async"
              src="../images/anroidqr.png"
              width="70"
              height="70"
            >
          </div>
        </v-layout>
      </div>
      <div class="caption ml-4 mr-4 pl-2">
        <div class="mb-1">
          掃碼加入LINE
        </div>
        <v-layout justify-center>
          <div
            class="white--text text-center"
            style="background: #06B833;border-radius: 5px;"
          >
            <div>
              Line
            </div>
            <v-divider />
            <img
              loading="lazy"
              decoding="async"
              :src="$store.state.option.optionApp.fe_line_link.newbieQrImg | upyun"
              width="70"
              style="vertical-align: middle;"
            >
          </div>
        </v-layout>
      </div>
      <!-- <div
        class="mr-4"
      >
        <a
          href="https://line.me/R/ti/p/@KKREN"
          target="_blank"
          style="text-decoration: none;display: block;"
        >
          <div style="line-height: 60px;height: 66px;">
            <i
              class="iconfont iconline"
              style="color:#00b900;background: #fff;font-size: 60px;display: block;"/>
          </div>
          <div class="caption">
            @KKREN
          </div>
        </a>
      </div>
      <div class="pr-4 mr-4">
        <img
          src="../images/appQrcode.png"
          width="60">
        <div class="caption">
          APP 下载
        </div>
      </div> -->
    </v-layout>
    <DocEvent @scroll="onScroll" />
  </div>
</template>
<script>
export default {
  props: {
    closeFixed: Boolean,
  },
  data () {
    return {
      isFixedFooter: false,
    }
  },
  methods: {
    onScroll () {
      this.isFixedFooter = window.scrollY > window.innerHeight
    },
  },
}
</script>
<style lang="postcss" scoped>
.footer {
  background: #1E1B29;
  color: #fff;
  a {
    color: #fff;
    text-decoration: none;
  }
  /* &.fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 9;
  } */
  img {
    vertical-align: middle;
  }
}
</style>
